<template>
  <v-dialog v-model="val" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{title}}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <inputs v-if="val" :data="inputs" ref="inputs"></inputs>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="cancel" v-if="isEdit">取消</v-btn>
        <v-btn color="primary" flat @click="ensure">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Inputs from './inputs'
export default {
  name: 'dialogForm',
  data () {
    return {
      val: false,
      type: '',
      title: '',
      inputs: [],
      validator: null,
      isEdit: true
    }
  },
  methods: {
    show (title, inputs, data, validator) {
      this.isEdit = true
      this.title = title
      this.validator = validator
      this.inputs = JSON.parse(JSON.stringify(inputs))
      this.val = true
      return new Promise(async (resolve, reject) => {
        await this.$nextTick()
        this.$refs.inputs.loadData(data)
        this.$once('close', (type) => {
          this.val = false
          if (type === 'ensure') {
            let data = this.$refs.inputs.getData()
            resolve(data)
          } else {
            reject('canceld')
          }
        })
      })
    },
    view (title, inputs, data) {
      this.isEdit = false
      this.title = title
      this.validator = null
      this.inputs = JSON.parse(JSON.stringify(inputs))
      this.val = true
      return new Promise(async (resolve, reject) => {
        await this.$nextTick()
        this.$refs.inputs.loadData(data)
        this.$once('close', (type) => {
          this.val = false
          reject('canceld')
        })
      })
    },
    cancel () {
      this.$emit('close', 'cancel')
    },
    ensure () {
      if (this.validator) {
        let data = this.$refs.inputs.getData()
        let errors = this.validator(data)
        if (errors) {
          this.$refs.inputs.setErrors(errors)
          return
        }
      }
      this.$emit('close', 'ensure')
    }
  },
  components: { Inputs }
}
</script>

<style scoped>

</style>
